import {RouteDescriptor} from "../../RouteDescriptor";
import {Route} from "../../Route";
import {MessageTemplatesPage} from "../../../../../pages/Lk/Shared/MessageTemplates/MessageTemplatesPage";
import {Role} from "../../../roles/Role";
import {groupApproved, groupNotApproved} from "../../../roles/groups";
import {PageGroupMessages, PageGroups} from "../../pageGroups";
import {defineMessage} from "react-intl";

const MessageTemplatesRouteTitleMessage = defineMessage({
  id: "messageTemplatesRoute.title",
  defaultMessage: "Message Templates",
})

export const messageTemplates: RouteDescriptor<Route.messageTemplates> = {
  route: Route.messageTemplates,
  render: MessageTemplatesPage,
  title: MessageTemplatesRouteTitleMessage,
  path: '/lk/message-templates',
  allowRoles: [
    Role.admin,
    ...groupApproved,
  ],
  redirectToHomeRoles: [
    ...groupNotApproved,
  ],
  showInSidebar: true,
  group: PageGroups.PROFILE,
  groupTitle: PageGroupMessages.profile,
}

